import { lazyWithPreload } from '../../navigation';

export const TrashScreen = lazyWithPreload(() =>
    import('./TrashScreen').then((m) => ({ default: m.TrashScreen }))
);
